function setCookie(name, value, maxAgeSeconds) {
	document.cookie = `${name}=${value}; max-age=${maxAgeSeconds}; path=/`;
}

function getCookie(name) {
	var m = document.cookie.match(new RegExp(`(?:^| )${name}=([^;]+)`));
	return m ? m[1] : undefined;
}

export function storeRwg(rwgToken, merchantId) {
	if (!rwgToken || !merchantId) return;
	var data = { t: rwgToken || null, m: merchantId || null };
	var encoded = encodeURIComponent(JSON.stringify(data));
	setCookie("_rwg", encoded, 2592000);
}

export function readRwg(merchantId) {
	var raw = getCookie("_rwg");
	if (!raw) return null;
	try {
		var obj = JSON.parse(decodeURIComponent(raw));
		if (merchantId && obj.m !== merchantId) {
			return null;
		}
		return { token: (obj && obj.t) || undefined, merchant: (obj && obj.m) || undefined };
	} catch (e) {
		return null;
	}
}
